import React from 'react';

export default function CheckBox(props) {
  const inputId = props.inputId || 'input-'
  + props.name + '-' + encodeURI(props.value);
  const label = props.label || props.name;
  const value = props.value || '';

  return (<div className="checkbox">
    <label>
      <input type="checkbox" name={props.name} id={inputId} value={value}
        checked={props.checked} onChange={props.onChange} disabled={props.disabled}/> {label}
    </label>
  </div>);
}



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/CheckBox.jsx